import { render, staticRenderFns } from "./DocumentItemsProfitCard.vue?vue&type=template&id=fe078b88&scoped=true"
import script from "./DocumentItemsProfitCard.vue?vue&type=script&lang=js"
export * from "./DocumentItemsProfitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe078b88",
  null
  
)

export default component.exports